import React, { useState } from 'react'
import { useNavigate } from '@tanstack/react-router'
import { useAuth } from '../_shared/authService'
import { CssBaseline, Typography, Button, Box, TextField, Avatar, useTheme, Container, Collapse, Stack } from '@mui/material'

import LockOutlinedIcon from '@mui/icons-material/LockOutlined'
export type LoginPageProps = {
  isSignUp: boolean
}

export const LoginPage: React.FC<LoginPageProps> = (props) => {
  const theme = useTheme()
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [confirmPassword, setConfirmPassword] = useState('')
  const [isSignUp, setIsSignUp] = useState(props.isSignUp)
  const [errorMessage, setErrorMessage] = useState<string>()
  const { signUp, signIn } = useAuth()
  const navigate = useNavigate()
  const handleSignIn = async (e: { preventDefault: () => void }) => {
    e.preventDefault()
    setErrorMessage(undefined)
    try {
      const signInResult = await signIn(email, password)
      if (signInResult.isSuccess) {
        console.log('Sign in successful')
        navigate({ to: '/' })
      } else {
        setErrorMessage(`ログインに失敗しました: ${JSON.stringify(signInResult.error)}`)
      }
    } catch (error) {
      console.error('Error signing in: ', error)
      setErrorMessage(`ログインに失敗しました: ${JSON.stringify(error)}`)
    }
  }
  const handleSignUp = async (e: { preventDefault: () => void }) => {
    e.preventDefault()
    setErrorMessage(undefined)
    if (password !== confirmPassword) {
      setErrorMessage('確認用パスワードが異なります。もう一度入力してください。')
      return
    }
    const signUpResult = await signUp(email, password)
    if (signUpResult.isSuccess) {
      console.log('Sign up successful')
      navigate({ to: '/confirm', search: { email } })
    } else {
      setErrorMessage(`アカウント作成に失敗しました: ${JSON.stringify(signUpResult.error)}`)
    }
  }
  return (
    <Container component="main" maxWidth="xs">
      <CssBaseline />
      <Box
        sx={{
          marginTop: 8,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
        }}
      >
        <Avatar sx={{ m: 1, bgcolor: 'secondary.main' }}>
          <LockOutlinedIcon />
        </Avatar>
        <Typography component="h1" variant="h5">
          {isSignUp ? 'アカウント作成' : 'ログイン'}
        </Typography>
        <Box
          component="form"
          onSubmit={(e) => {
            void (async () => {
              if (isSignUp) {
                await handleSignUp({ preventDefault: () => e.preventDefault() })
              } else {
                await handleSignIn({ preventDefault: () => e.preventDefault() })
              }
            })()
          }}
          noValidate
          sx={{ mt: 1 }}
        >
          <TextField
            margin="normal"
            required
            fullWidth
            id="email"
            label="メールアドレス"
            name="email"
            autoComplete="email"
            autoFocus
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
          <TextField
            margin="normal"
            required
            fullWidth
            name="password"
            label="パスワード"
            type="password"
            id="password"
            autoComplete="current-password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />
          {isSignUp && (
            <TextField
              margin="normal"
              required
              fullWidth
              name="confirmPassword"
              label="パスワード確認"
              type="password"
              id="confirmPassword"
              autoComplete="current-password"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
            />
          )}
          <Collapse in={!!errorMessage}>
            <Stack
              direction="row"
              alignItems="center"
              sx={{ borderWidth: 1, borderStyle: 'solid', borderColor: theme.palette.error.main, borderRadius: 1 }}
              spacing={1}
              px={2}
              py={1}
            >
              <Typography variant="caption" color="error">
                {errorMessage}
              </Typography>
            </Stack>
          </Collapse>
          <Button type="submit" fullWidth variant="contained" sx={{ mt: 3, mb: 2 }}>
            {isSignUp ? 'サインアップ' : 'ログイン'}
          </Button>
          {!isSignUp ? (
            <>
              アカウントをお持ちではありませんか？
              <Button onClick={() => setIsSignUp(!isSignUp)}>サインアップ</Button>
            </>
          ) : (
            <>
              既にアカウントをお持ちですか？
              <Button onClick={() => setIsSignUp(!isSignUp)}>ログイン</Button>
            </>
          )}
        </Box>
      </Box>
    </Container>
  )
}
export default LoginPage
